import _ from 'lodash';
import LiveboardsUrlConverter from './liveboards_url_converter';

export default _.extend({}, LiveboardsUrlConverter, {
  getPath() {
    return '/liveboards/floorboard';
  },
});
